const DEFAULT_MAP_ID = x => x.id;

function dataloader(
	$q,
	$logger
) {
	this.newLoader = newLoader;

	function newLoader(...args) {
		return new Loader(...args);
	}

	function Loader(
		batchCall,
		{
			wait = 20,
			mapKeyFn = DEFAULT_MAP_ID,
			cacheArgFn = x => x,
			limit = -1
		} = {}
	) {
		let cache = {};
		const queuedKeys = [];

		const processBatch = () => {
			const args = [...queuedKeys];

			queuedKeys.length = 0;

			return batchCall(args).then(
				(resp) => resp.forEach(x => cache[mapKeyFn(x)].resolve(x)),
				(err) => {
					$logger.exception(err, "Error in map data-loader cache");
				}
			)
				.catch(err =>
					$logger.exception(err, "Error in map data-loader batch")
				);
		};

		const debouncedProcessBatch = debounce(processBatch, wait);

		return {
			load(key) {
				if(!cache[cacheArgFn(key)]) {
					cache[cacheArgFn(key)] = getResolvablePromise();
					queuedKeys.push(key);

					if(limit && queuedKeys.length == limit) {
						debouncedProcessBatch.cancel();
						processBatch();
					} else {
						debouncedProcessBatch();
					}
				}

				return cache[cacheArgFn(key)];
			},
			clear(key) {
				if(key) {
					delete cache[cacheArgFn(key)];
				} else {
					cache = {};
				}
			},
			flush() {
				debouncedProcessBatch.cancel();
				processBatch();
			}
		};
	}

	function getResolvablePromise() {
		let resolve;
		let reject;

		const p = $q((res, rej) => {
			resolve = res;
			reject = rej;
		});

		p.resolve = val => resolve(val);
		p.reject = val => reject(val);

		return p;
	}

	function debounce(func, wait, immediate) {
		let timeout;

		fn.cancel = () => clearTimeout(timeout);
		return fn;

		function fn() {
			const context = this;
			const args = arguments;
			const callNow = immediate && !timeout;

			clearTimeout(timeout);
			timeout = setTimeout(later, wait);

			if(callNow) {
				func.apply(context, args);
			}

			function later() {
				timeout = null;
				if(!immediate) {
					func.apply(context, args);
				}
			}
		}
	}
}

export default angular
	.module("vesl.services.dataloader", [])
	.service("dataloader", dataloader).name;
